import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './i18n';
import './index.css';

// Uppsala UI
import 'uppsala-ui';
import 'uppsala-ui/dist/tokens/colors.css';
import 'uppsala-ui/dist/tokens/fontsize.css';
import 'uppsala-ui/dist/tokens/spacing.css';

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
